function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17 8.667h-.833V7c0-2.3-1.867-4.167-4.167-4.167A4.168 4.168 0 0 0 7.833 7v1.667H7c-.917 0-1.667.75-1.667 1.666v8.334c0 .916.75 1.666 1.667 1.666h10c.917 0 1.667-.75 1.667-1.666v-8.334c0-.916-.75-1.666-1.667-1.666zm-5 7.5c-.917 0-1.667-.75-1.667-1.667s.75-1.667 1.667-1.667 1.667.75 1.667 1.667-.75 1.667-1.667 1.667zm2.583-7.5H9.417V7A2.586 2.586 0 0 1 12 4.417 2.586 2.586 0 0 1 14.583 7v1.667z"
});
const SvgIconDevIcLockOn = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDevIcLockOn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-dev-ic-lock-on.0b4debea.svg";
export { ForwardRef as ReactComponent };